import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Features from "./features/Features";
import Guidance_Service from "./guidance-service/Guidance_Service";
import Why_Choose from "./why-choose/Why_Choose";
import Our_Published_Books from "./our-published-books/Our_Published_Books";
import Moments_From_Workshop from "./moments-from-workshop/Moments_From_Workshop";
import What_Student_Say from "./what-student-say/What_Student_Say";
import Our_Blogs from "./our-blogs/Our_Blogs";
import FAQ from "./faq/FAQ";
import { GetAllCount, GetAllfaq, GetAllfeedback, GetAllwhychoose } from "../../redux/aboutus";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

function Home() {
 const dispatch = useDispatch();
  const count = useSelector(state => state?.aboutus?.count);
  const whychoose = useSelector(state => state?.aboutus?.whychoose);
  const faq = useSelector(state => state?.aboutus?.faq);
  const feedback = useSelector(state => state?.aboutus?.feedback);

   useEffect(() => {
      dispatch(GetAllCount());
      dispatch(GetAllwhychoose());
      dispatch(GetAllfaq());
      dispatch(GetAllfeedback());
    
    }, [dispatch]);


  return (
    <>
      <Banner />
      <Features count={count} />
      <Guidance_Service />
      <Why_Choose whychoose={whychoose}/>
      <Our_Published_Books />
      <Moments_From_Workshop />
      <What_Student_Say feedback={feedback} />
      <Our_Blogs />
      <FAQ faq={faq} />
    </>
  );
}

export default Home;
